import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import RackMasterTable from '../components/RackMasterTable';

const RackMaster = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isRackMasterModalOpen, setIsRackMasterModalOpen] = useState(false);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.RACK_MASTER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_RACK,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsRackMasterModalOpen(true);
            }}
          >
            Add New Shelf Master
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_RACK,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsRackMasterModalOpen(true);
            }}
          >
            Add New Shelf Master
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <RackMasterTable
          isRackMasterModalOpen={isRackMasterModalOpen}
          setIsRackMasterModalOpen={setIsRackMasterModalOpen}
        />
      </Card>
    </>
  );
};

export default RackMaster;
